
import { rootApi } from "../../api/rootApi";

export const aqualiteApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    aqualiteDistributorScans: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/aqualite/distributor-scan`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    aqualiteDistributorScansCount: builder.mutation({
        query: (params) => {
          return {
            method: "POST",
            url: `/tenant/aqualite/distributor-count`,
            headers: {
                Authorization: "Bearer " + params.token,
                slug: params.tenant_id,
              },
              body: params.body,
          };
        },
      }),
      aqualiteQrSyncStats: builder.mutation({
        query: (params) => {
          return {
            method: "POST",
            url: `/tenant/aqualite/qr-sync-stats?${params.queryParams}`,
            headers: {
                Authorization: "Bearer " + params.token,
                slug: params.tenant_id,
              },
          };
        },
      }),
      aqualiteQrSyncStatsByBatchNo: builder.mutation({
        query: (params) => {
          return {
            method: "POST",
            url: `/tenant/aqualite/qr-sync-stats/${params.batch_no}`,
            headers: {
                Authorization: "Bearer " + params.token,
                slug: params.tenant_id,
              },
              body: params.body,
          };
        },
      }),
      aqualitePendingUser: builder.mutation({
        query: (params) => {
          return {
            method: "POST",
            url: `/tenant/aqualite/pending-user`,
            headers: {
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
            body: params.body,
          };
        },
      }),
      getDetailedSchemeList: builder.mutation({
        query: ({token, tenant_id, body}) => {
          return {
            method: "POST",
            url: `/tenant/aqualite/detailed-wallet-report`,
            headers: {
              Authorization: "Bearer " + token,
              slug: tenant_id,
            },
            body: body,
          };
        },
      }),
      aqualiteInvoiceList: builder.mutation({
        query: (params) => {
          return {
            method: "POST",
            url: `/tenant/aqualite/invoice-list`,
            headers: {
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
            body: params.body,
          };
        },
      }),
      aqualiteInvoiceDetail: builder.mutation({
        query: (params) => {
          return {
            method: "GET",
            url: `/tenant/aqualite/invoice/${params.invoice_id}`,
            headers: {
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
        },
      }),
      listSchemeAssignedUsers: builder.mutation({
        query: (params) => ({
          method: "POST",
          url: `/tenant/aqualite/scheme-users/list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        }),
      }),
      searchUsersForSchemeAssignment: builder.mutation({
        query: (params) => ({
          method: "POST",
          url: `/tenant/aqualite/scheme-users/search`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        }),
      }),
      assignSchemeToUsers: builder.mutation({
        query: (params) => ({
          method: "POST",
          url: `/tenant/aqualite/scheme-users/assign`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        }),
      }),
      bulkAssignSchemeToUsers: builder.mutation({
        query: (params) => {
          const formData = new FormData();
          formData.append("file", params.file);
          formData.append("scheme_id", params.scheme_id);
          return {
            method: "POST",
            url: `/tenant/aqualite/scheme-users/bulk-assign`,
            headers: {
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
            body: formData,
          };
        },
      }),
  }),
});

export const {
  useAqualiteDistributorScansCountMutation,
  useAqualiteDistributorScansMutation,
  useAqualiteQrSyncStatsMutation,
  useAqualiteQrSyncStatsByBatchNoMutation,
  useAqualitePendingUserMutation,
  useGetDetailedSchemeListMutation,
  useAqualiteInvoiceListMutation,
  useAqualiteInvoiceDetailMutation,
  useListSchemeAssignedUsersMutation,
  useSearchUsersForSchemeAssignmentMutation,
  useAssignSchemeToUsersMutation,
  useBulkAssignSchemeToUsersMutation,
} = aqualiteApi;
